import { render } from "./StatBarChart.vue?vue&type=template&id=22eb3cec&scoped=true"
import script from "./StatBarChart.vue?vue&type=script&lang=js"
export * from "./StatBarChart.vue?vue&type=script&lang=js"

import "./StatBarChart.vue?vue&type=style&index=0&id=22eb3cec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22eb3cec"]])

export default __exports__